import http from "./http";

export const fetchEcpAuth = (payload) => {
  // return http.post("/parent/ecp-auth");
  return http.post("/landing/parent/ecp-auth", payload);
};

export const fetchEcpSSOAuth = (payload) => {
  return http.post("/landing/parent/sso-auth", payload);
};
